/** The browser's entry point: mount the application on #root. */
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';

const container = document.getElementById('root');
if (!container) throw new Error('the page has no #root to mount on');
createRoot(container).render(React.createElement(App));
